import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { StatusRo } from './status-ro';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-status-ro',
  templateUrl: './status-ro.component.html'
})
export class StatusRoComponent 
extends BaseModalContainer<StatusRo>  
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<StatusRo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
